import React, { useContext, useEffect, useState } from 'react';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import { AuthContext } from './../AuthContext';
import { site_url_img } from "./../config.js";

function Index() {
  const { user, refreshUser, vendordetails } = useContext(AuthContext);

  return (
    <div>
<div id="appCapsule">
  <div className="section mt-3 text-center">
    <div className="avatar-section">
      <a href="#">
        <img src={site_url_img+'/'+user?.shop_img} alt="avatar" className="imaged w100 rounded" />
        <span className="button">
          <ion-icon name="camera-outline" role="img" className="md hydrated" aria-label="camera outline" />
        </span>
      </a>
    </div>
  </div>

  <div className="listview-title mt-1">Profile Settings</div>
  <ul className="listview image-listview text inset">
    <li>
      <a href="#" className="item">
        <div className="in">
          <div>{user?.username}</div>
        </div>
      </a>
    </li>
    <li>
      <a href="#" className="item">
        <div className="in">
          <div>{user?.phone}</div>
        </div>
      </a>
    </li>
    <li>
      <a href="#" className="item">
        <div className="in">
          <div>{user?.address} {user?.city}/{user?.state}-{user?.pincode}</div>
          <span className="text-primary">Edit</span>
        </div>
      </a>
    </li>
    <li>
      <a href="#" className="item">
        <div className="in">
          <div>{user?.gst}</div>
        </div>
      </a>
    </li>
   
  </ul>
  <div className="listview-title mt-1">Security</div>
  <ul className="listview image-listview text mb-2 inset">
    <li>
      <a href="#" className="item">
        <div className="in">
          <div>Update Password</div>
        </div>
      </a>
    </li>
   
    <li>
      <a href="#" className="item">
        <div className="in">
          <div>Log out all devices</div>
        </div>
      </a>
    </li>
  </ul>
</div>

<Footer />
<Sidebar />
    </div>
  )
}

export default Index